"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opportunityLocksBeforeStartTime = exports.matchShiftWithTimeoff = exports.countShiftsByDate = exports.hasDropPenalty = exports.isUndroppable = exports.DROP_PENALTY_HOURS = void 0;
var luxon_1 = require("luxon");
var atoz_shiftapp_types_1 = require("@amzn/atoz-shiftapp-types");
exports.DROP_PENALTY_HOURS = 16;
function isUndroppable(dropDeadline) {
    return !dropDeadline || luxon_1.DateTime.local() > luxon_1.DateTime.fromISO(dropDeadline);
}
exports.isUndroppable = isUndroppable;
function hasDropPenalty(_a) {
    var shiftEndTime = _a.shiftEndTime, penaltyStartTime = _a.penaltyStartTime;
    if (!penaltyStartTime) {
        return false;
    }
    var hasPenaltyStartTimePassed = penaltyStartTime <= luxon_1.DateTime.local();
    var isShiftOver = shiftEndTime <= luxon_1.DateTime.local();
    return hasPenaltyStartTimePassed && !isShiftOver;
}
exports.hasDropPenalty = hasDropPenalty;
var countShiftsByDate = function (shifts, dateTime) {
    var startOfDay = dateTime.startOf('day');
    return shifts.filter(function (shift) {
        var shiftStartDateTime = luxon_1.DateTime.fromISO(shift.timeRange.start);
        return shiftStartDateTime.startOf('day').equals(startOfDay);
    }).length;
};
exports.countShiftsByDate = countShiftsByDate;
var MATCHING_STATUS = [
    atoz_shiftapp_types_1.TimeOffEntryStatus.Approved,
    atoz_shiftapp_types_1.TimeOffEntryStatus.Autoapproved,
    atoz_shiftapp_types_1.TimeOffEntryStatus.Pending
];
var EXCLUDED_TIMEOFF_OPTION = ['TimeOff_USA_GSF_VTO'];
var matchShiftWithTimeoff = function (shift, rawTimeoffEntries) {
    var timeoffs = rawTimeoffEntries
        .filter(function (_a) {
        var status = _a.status, optionId = _a.optionId;
        return MATCHING_STATUS.includes(status) &&
            !EXCLUDED_TIMEOFF_OPTION.includes(optionId);
    })
        .map(function (entry) { return ({
        timeoffStart: luxon_1.DateTime.fromISO(entry.startAt).toMillis(),
        timeoffEnd: luxon_1.DateTime.fromISO(entry.endAt).toMillis(),
        timeoffEntry: entry
    }); })
        .sort(function (e1, e2) { return e1.timeoffStart - e2.timeoffStart; });
    var shiftStart = luxon_1.DateTime.fromISO(shift.timeRange.start).toMillis();
    var shiftEnd = luxon_1.DateTime.fromISO(shift.timeRange.end).toMillis();
    var timeoffEntries = [];
    for (var _i = 0, timeoffs_1 = timeoffs; _i < timeoffs_1.length; _i++) {
        var timeoff = timeoffs_1[_i];
        var timeoffStart = timeoff.timeoffStart, timeoffEnd = timeoff.timeoffEnd, timeoffEntry = timeoff.timeoffEntry;
        // Shift is before timeoff
        if (shiftEnd <= timeoffStart) {
            continue;
        }
        // Timeoff is before shift
        if (timeoffEnd <= shiftStart) {
            continue;
        }
        // There is an overlap
        timeoffEntries.push(timeoffEntry);
    }
    return timeoffEntries;
};
exports.matchShiftWithTimeoff = matchShiftWithTimeoff;
var opportunityLocksBeforeStartTime = function (shiftStartTime, dropDeadline) {
    if (!dropDeadline) {
        return false;
    }
    var shiftStart = luxon_1.DateTime.fromISO(shiftStartTime);
    var dropDeadlineTime = luxon_1.DateTime.fromISO(dropDeadline);
    return dropDeadlineTime < shiftStart;
};
exports.opportunityLocksBeforeStartTime = opportunityLocksBeforeStartTime;
